<template>
    <div id="reservation-event-modal">
        <a-modal :visible="true" cancelText="Vazgeç" okText="Kaydet" centered @cancel="$emit('close')" :footer="null">
            <div class="container">
                <div class="label-container">
                    <span class="material-icons icon">calendar_month</span>
                    <span class="label">Reservation</span>
                </div>
                <div class="title" style="font-size: 17px">{{ reservationDetail.title }}</div>
                <div class="title">{{ getDate() }}</div>
                <div class="duration-container">
                    <span class="material-icons icon">timelapse</span>
                    <span class="duration"> {{ reservationDetail.duration }} min appointments </span>
                </div>
                <SupsisButton class="go-link" @click="goLink()">
                    <span class="material-icons icon">open_in_new</span>
                    Linke Git
                </SupsisButton>
                <div class="form">
                    <div class="material-icons icon">format_list_bulleted</div>
                    <div class="right">
                        <div class="form-title">Booking form</div>
                        <div class="items">
                            <div class="item" v-for="(formInput, i) in eventDetail.formValues">
                                <span class="label">{{ formInput.label + ": " }}</span>
                                {{ formInput.value }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="buttons">
                    <SupsisButton @click="editReservation()" class="button edit">Düzenle</SupsisButton>
                    <SupsisButton @click="deleteEvent()" class="button edit" v-if="isDeletable()">Sil</SupsisButton>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../../utils/log2";
import { CALENDAR_API } from "../../../../api/calendar";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import CONFIG from "../../../../config/config";
import moment from "moment";

const log = log2("CalendarTest");
export default {
    name: "ReservationEventModal",
    components: {
        SupsisButton,
    },
    props: {
        eventDetail: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            reservationDetail: {},
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
        }),
        ...mapGetters({}),
    },
    methods: {
        getDate() {
            return (
                moment(this.eventDetail.start).utc(this.eventDetail.timezone).format("LLLL") +
                ` - ${moment(this.eventDetail.end).format("HH:mm")}`
            );
        },
        goLink() {
            const reservationURL = `${CONFIG.CALENDAR_URL}/?reservationId=${this.eventDetail.reservationId}&siteId=${this.site._id}&userId=${this.user._id}`;
            window.open(reservationURL, "_blank");
        },
        editReservation() {
            this.$router.replace(`/reservation/${this.eventDetail.reservationId}`);
        },
        deleteEvent() {
            const data = {
                userId: this.user._id,
                eventId: this.eventDetail._id,
            };
            CALENDAR_API.deleteCalendarEvent(data).then((res) => {
                this.$emit("deleteEvent", this.eventDetail);
            });
        },
        isDeletable() {
            return this.eventDetail.userId === this.user._id;
        },
    },
    async mounted() {
        console.log("this.eventDetail-->", this.eventDetail);
        await CALENDAR_API.getReservationPlan(this.eventDetail.reservationId).then((res) => {
            console.log("getReservationPlan-->", res);
            this.reservationDetail = res;
        });
    },
    watch: {},
};
</script>

<style lang="scss" scoped>
.container {
    padding-left: 30px;

    .label-container {
        display: flex;
        align-items: center;

        .label {
            font-weight: 700;
            font-size: 20px;
            margin-left: 5px;
        }

        .icon {
        }
    }

    .title {
        font-size: 15px;
        font-weight: 500;
        margin-top: 10px;
    }

    .duration-container {
        display: flex;
        align-items: center;
        margin-left: -30px;

        .icon {
            font-size: 20px;
            margin-right: 10px;
        }

        .duration {
        }
    }

    .go-link {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-top: 10px;
        padding: 5px;

        .icon {
            font-size: 15px;
            margin-right: 5px;
        }
    }

    .form {
        display: flex;
        margin-left: -30px;
        margin-top: 10px;
        align-items: start;

        .icon {
            font-size: 20px;
            margin-right: 10px;
            margin-top: 15px;
        }

        .right {
            .form-title {
                font-size: 15px;
                font-weight: 500;
                margin-top: 10px;
            }

            .items {
                display: flex;
                flex-direction: column;

                .item {
                    .label {
                        font-weight: 600;
                    }
                }
            }
        }
    }

    .buttons {
        margin-top: 10px;
        display: flex;
        justify-content: end;

        .button {
            padding: 5px 10px !important;
            cursor: pointer;
            margin-right: 5px;

            &.edit {
            }

            &.delete {
                background-color: #b5b5b5;
            }
        }
    }
}
</style>
